<template>
  <div>
    <v-card-title class="text-h6 px-0">
      <v-icon start size="small">fal fa-lock</v-icon>
      Access Code Required
    </v-card-title>
    <v-card-text class="px-0 pb-2">
      This event requires an access code to purchase tickets.
    </v-card-text>
    <v-text-field
      :model-value="modelValue"
      @update:model-value="onInput"
      @keydown="onKeydown"
      label="Access Code"
      type="text"
      maxlength="20"
      counter="20"
      :rules="[alphanumericOnlyRule, minLengthRule, maxLengthRule]"
      :error-messages="errorMessage ? [errorMessage] : []"
      :disabled="loading"
      autofocus
      variant="outlined"
      hint="Enter the access code provided to you"
      persistent-hint
      class="mb-2"
    />
    <v-card-actions class="px-0 pt-0">
      <v-spacer />
      <v-btn variant="text" :disabled="loading" @click="emit('cancel')">
        Cancel
      </v-btn>
      <v-btn
        color="primary"
        variant="elevated"
        :loading="loading"
        :disabled="!modelValue || modelValue.length < 4"
        @click="emit('submit')"
      >
        Submit
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script setup lang="ts">
const modelValue = defineModel<string>({ default: "" });

defineProps<{
  errorMessage?: string | null;
  loading?: boolean;
}>();

const emit = defineEmits<{
  submit: [];
  cancel: [];
}>();

const alphanumericOnlyRule = (v: string) =>
  /^[a-zA-Z0-9]*$/.test(v) ||
  "Access code must contain only letters and numbers.";
const minLengthRule = (v: string) =>
  v.length >= 4 || "Access code must be at least 4 characters.";
const maxLengthRule = (v: string) =>
  v.length <= 20 || "Access code must be at most 20 characters.";

function onInput(value: string) {
  const cleaned = value.replace(/[^a-zA-Z0-9]/g, "").slice(0, 20);
  modelValue.value = cleaned;
}

function onKeydown(e: KeyboardEvent) {
  if (e.key === "Enter") {
    emit("submit");
  }
}
</script>
